import { render, staticRenderFns } from "./RoleFeatures.vue?vue&type=template&id=3683b5a6&scoped=true&"
import script from "./RoleFeatures.vue?vue&type=script&lang=ts&"
export * from "./RoleFeatures.vue?vue&type=script&lang=ts&"
import style0 from "./RoleFeatures.vue?vue&type=style&index=0&id=3683b5a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3683b5a6",
  null
  
)

export default component.exports